/**
 * Use Shopify Currency API to retrieve exchange rates for all foreign currencys in our shop (SEK, PLN)
 * Store data to cart attributes to use them later within the Cart transform Function
 * Use Case: convert addon-prices (set in current market currency), if market changes in checkout
 */

function waitForCurrency(callback) {
  if (typeof Currency !== "undefined") {
    callback();
  } else {
    console.log("Currency API not ready yet");
    setTimeout(function () {
      waitForCurrency(callback);
    }, 100);
  }
}

waitForCurrency(function () {
  saveExchangeRatesToCart();
});

function saveExchangeRatesToCart() {
  try {
    const exchangeRates = {
      SEK: Currency.convert(100, "SEK", "EUR") / 100,
      PLN: Currency.convert(100, "PLN", "EUR") / 100,
      timestamp: new Date().toISOString(),
    };

    const exchangeRatesJSON = JSON.stringify(exchangeRates);

    fetch("/cart/update.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        attributes: {
          _dt_exchange_rates: exchangeRatesJSON,
        },
      }),
    })
      .then((response) => response.json())
      .then((data) => {
        console.log("Exchange rates successfully saved:", data);
      })
      .catch((error) => {
        console.error("Error on saving exchange rates:", error);
      });
  } catch (error) {
    console.error("Error on setting excange rates:", error);
  }
}
